module.exports = __webpack_public_path__ + "img/26.93af8811.jpg";